import React from "react";

import { Avatar, CardHeader } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

import { i18n } from "../../translate/i18n";

const useStyles = makeStyles(() => ({
	content: {
		overflow: "hidden",
		minWidth: 0,
	},
}));

const TicketInfo = ({ contact, ticket, onClick }) => {
	const classes = useStyles();
	return (
		<CardHeader
			onClick={onClick}
			classes={{ content: classes.content }}
			style={{ cursor: "pointer", padding: "8px 12px" }}
			titleTypographyProps={{ 
				noWrap: true, 
				variant: "subtitle1",
				style: { fontWeight: 600, color: "inherit" } 
			}}
			subheaderTypographyProps={{ 
				noWrap: true,
				variant: "caption",
				style: { color: "#64748B", fontWeight: 500 }
			}}
			avatar={<Avatar src={contact.profilePicUrl} alt="contact_image" style={{ width: 40, height: 40 }} />}
			title={contact.name}
			subheader={
				ticket.user &&
				`${i18n.t("messagesList.header.assignedTo")} ${ticket.user.name}`
			}
		/>
	);
};

export default TicketInfo;
